import { Row, Col, Card, Typography, Spin, Tooltip, Progress } from "antd";
import { 
  FaUsers, 
  FaUserCheck, 
  FaUserClock, 
  FaUserTimes, 
  FaPhone, 
  FaChartLine, 
  FaCalendarDay, 
  FaUserMinus,
  FaInfoCircle,
  FaMale,
  FaFemale 
} from "react-icons/fa";
const { Title, Text } = Typography;

export default function TotalesCards({
  totales,
  metricasLlamadas,
  tasaExito,
  promedioDia,
  noVerificadosTotales,
  loading = false
}) {

  // Mostrar spinner mientras carga
  if (loading || !totales) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
        <Spin size="large" tip="Cargando métricas..." />
      </div>
    );
  }

  // Calcular porcentajes
  const totalContactados = totales.totalContactados || 0;
  const llamadasRealizadas = metricasLlamadas?.llamadasRealizadas || 0;
  
  const getPercentage = (value) => {
    return totalContactados > 0 ? ((value / totalContactados) * 100).toFixed(1) : 0;
  };

  // Función para formatear información de género
const getGenderInfo = (hombres, mujeres) => {
  const total = (hombres || 0) + (mujeres || 0);
  // Eliminar la condición que devuelve cadena vacía cuando total es 0
  const porcentajeHombres = total > 0 ? ((hombres / total) * 100).toFixed(0) : 0;
  const porcentajeMujeres = total > 0 ? ((mujeres / total) * 100).toFixed(0) : 0;
  
  return (
    <div style={{ fontSize: 11, color: '#666', marginTop: 4 }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <FaMale size={10} color="#3B82F6" /> {hombres || 0} ({porcentajeHombres}%) <FaFemale size={10} color="#EC4899" /> {mujeres || 0} ({porcentajeMujeres}%)
      </span>
    </div>
  );
};

  const cards = [
    { 
      label: "Total participantes", 
      value: totales.totalParticipantes || 0,
      icon: <FaUsers size={28} color="#2979FF" />,
      color: "#2979FF",
      tooltip: "Número total de participantes registrados en el sistema",
      showPercentage: false,
      extraInfo: getGenderInfo(totales.hombresTotales, totales.mujeresTotales),
      showGender: true
    },
    { 
      label: "Verificados", 
      value: totales.verificados?.total || 0, 
      icon: <FaUserCheck size={28} color="#20AC00" />,
      color: "#20AC00",
      tooltip: `Participantes verificados exitosamente - ${getPercentage(totales.verificados?.total || 0)}% del total`,
      percentage: getPercentage(totales.verificados?.total || 0),
      showPercentage: true,
      extraInfo: getGenderInfo(totales.verificados?.hombres, totales.verificados?.mujeres)
    },
    { 
      label: "En proceso", 
      value: totales.enProceso?.total || 0, 
      icon: <FaUserClock size={28} color="#419DF8" />,
      color: "#419DF8",
      tooltip: `Participantes en proceso de validación - ${getPercentage(totales.enProceso?.total || 0)}% del total`,
      percentage: getPercentage(totales.enProceso?.total || 0),
      showPercentage: true,
      extraInfo: getGenderInfo(totales.enProceso?.hombres, totales.enProceso?.mujeres)
    },
    { 
      label: "No Continúa", 
      value: totales.noContinua?.total || 0, 
      icon: <FaUserTimes size={28} color="#D62828" />,
      color: "#D62828",
      tooltip: `Participantes que no pudieron ser verificados - ${getPercentage(totales.noContinua?.total || 0)}% del total`,
      percentage: getPercentage(totales.noContinua?.total || 0),
      showPercentage: true,
      extraInfo: getGenderInfo(totales.noContinua?.hombres, totales.noContinua?.mujeres)
    },
    { 
      label: "No Verificado", 
      // Usar totales.noVerificados en lugar de noVerificadosTotales
      value: totales.noVerificados?.total || 0,
      icon: <FaUserMinus size={28} color="#B4B4B4" />,
      color: "#B4B4B4",
      tooltip: `Participantes sin proceso de validación - ${getPercentage(totales.noVerificados?.total || 0)}% del total`,
      percentage: getPercentage(totales.noVerificados?.total || 0),
      showPercentage: true,
      extraInfo: getGenderInfo(totales.noVerificados?.hombres, totales.noVerificados?.mujeres)
    },
    { 
      label: "Llamadas Realizadas", 
      value: llamadasRealizadas, 
      icon: <FaPhone size={28} color="#7B1FA2" />,
      color: "#7B1FA2",
      tooltip: `Total de llamadas realizadas - ${getPercentage(llamadasRealizadas)}% respecto a participantes`,
      percentage: getPercentage(llamadasRealizadas),
      showPercentage: true,
    },
    { 
      label: "Tasa de Éxito", 
      value: tasaExito?.tasaExito ? `${Math.round(tasaExito.tasaExito)}%` : "0%", 
      icon: <FaChartLine size={28} color="#388E3C" />,
      color: "#388E3C",
      tooltip: `Llamadas exitosas: ${tasaExito?.llamadasExitosas || 0} de ${tasaExito?.totalLlamadas || 0} (${Math.round(tasaExito?.tasaExito || 0)}%)`,
      percentage: Math.round(tasaExito?.tasaExito || 0),
      showPercentage: true,
    },
    { 
      label: "Promedio Llamadas/Día", 
      value: promedioDia?.promedioLlamadasDia ? Math.round(promedioDia.promedioLlamadasDia) : 0, 
      icon: <FaCalendarDay size={28} color="#1976D2" />,
      color: "#1976D2",
      tooltip: `Promedio: ${promedioDia?.totalLlamadas || 0} llamadas en ${promedioDia?.diasConLlamadas || 0} días`,
      percentage: Math.min(100, Math.round((promedioDia?.promedioLlamadasDia || 0) / 10 * 100)),
      showPercentage: true,
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {cards.map((card, index) => (
        <Col xs={24} sm={12} lg={6} key={index}>
          <Tooltip title={card.tooltip} placement="top">
            <Card
              hoverable
              style={{
                borderRadius: 14,
                height: "100%",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                border: `1px solid ${card.color}20`,
                transition: "all 0.3s ease",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
                <div
                  style={{
                    background: `${card.color}15`,
                    padding: 10,
                    borderRadius: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {card.icon}
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <Title 
                    level={4} 
                    style={{ 
                      margin: 0, 
                      color: card.color,
                      fontSize: "24px",
                      lineHeight: "1.2",
                      marginBottom: 4
                    }}
                  >
                    {card.value}
                  </Title>
                  
                  <Text 
                    style={{ 
                      fontSize: 13, 
                      color: "#666",
                      fontWeight: 500,
                      display: "block",
                      marginBottom: 4
                    }}
                  >
                    {card.label}
                  </Text>
                  
                  {/* Información de género y porcentaje */}
                  {(card.showPercentage || card.extraInfo) && (
                    <div style={{ marginTop: 8 }}>
                      {/* Barra de progreso para visualización */}
                      {card.showPercentage && index >= 5 && ( // Solo para las últimas 3 tarjetas
                        <Progress 
                          percent={card.percentage} 
                          size="small" 
                          strokeColor={card.color}
                          showInfo={false}
                          style={{ marginBottom: 4 }}
                        />
                      )}
                      
                      <Text 
                        style={{ 
                          fontSize: 11, 
                          color: "#999",
                          display: "block",
                          lineHeight: "1.3"
                        }}
                      >
                        {card.showPercentage && `${card.percentage}%`}
                        {card.extraInfo && (
                          <>
                            {card.showPercentage && <br />}
                            {card.extraInfo}
                          </>
                        )}
                      </Text>
                    </div>
                  )}
                </div>
                
                {/* Icono de información para tooltip */}
                <div style={{ flexShrink: 0, opacity: 0.6 }}>
                  <FaInfoCircle size={12} color="#999" />
                </div>
              </div>
            </Card>
          </Tooltip>
        </Col>
      ))}
    </Row>
  );
}